import React, { useState } from 'react';
import classNames from 'classnames';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/bundle';
import Content from '@/components/foundations/content';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './caseStudies.module.scss';
import * as contentStyle from '@/components/foundations/content/content.module.scss';

const CaseStudiesContent: React.FC = () => {
  SwiperCore.use([Autoplay]);
  const [swiper, setSwiper] = useState<SwiperCore | null>(null);

  const swiperNavigation = (str: string) => {
    switch (str) {
      case 'prev':
        swiper?.slidePrev();
        break;
      case 'next':
        swiper?.slideNext();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <h2>
        <span>
          <strong>Case Studies</strong>
          <small>事例紹介</small>
        </span>
      </h2>
      <h3>
        <span>事業カテゴリを問わず、様々なサービス・アイデアの実現性を検証いたします。</span>
      </h3>
      <Swiper
        autoplay={true}
        loop={true}
        loopedSlides={2}
        slidesPerView={1}
        spaceBetween={24}
        centeredSlides={true}
        breakpoints={{
          769: {
            slidesPerView: 2.5,
            spaceBetween: 60,
          },
        }}
        onSwiper={setSwiper}
        className={styles.swiperWrapper}
      >
        <SwiperSlide className={styles.swiperSlide}>
          <dl className={styles.oCase}>
            <dt>
              ぴあアプリ<small>ぴあ株式会社さま</small>
            </dt>
            <dd>
              <StaticImage src="./img/pia.png" alt="ぴあアプリ ぴあ株式会社さま" />
            </dd>
            <dd>
              <p>
                アプリの本開発に向けた社内での最終決裁に際し、デザインモックアップを作成。データの整合性や、本番相当のコンテンツおよび画面遷移を再現できたことで、スムーズな合意形成が実現しました。
              </p>
            </dd>
          </dl>
        </SwiperSlide>
        <SwiperSlide className={styles.swiperSlide}>
          <dl className={styles.oCase}>
            <dt>
              進研ゼミ中学講座タブレット教材<small>株式会社ベネッセコーポレーションさま</small>
            </dt>
            <dd>
              <StaticImage src="./img/benesse.png" alt="進研ゼミ中学講座タブレット教材 株式会社ベネッセコーポレーションさま" />
            </dd>
            <dd>
              <p>
                タブレット講座のリニューアルにあたり、プロトタイプを制作。ユーザー調査から学習プロセスの妥当性を検証できたことにより、開発要件の精度が大きく向上しました。
              </p>
            </dd>
          </dl>
        </SwiperSlide>
        <SwiperSlide className={styles.swiperSlide}>
          <dl className={styles.oCase}>
            <dt>
              簡単瞑想アプリ寝たまんまヨガ<small>株式会社ヨギーさま</small>
            </dt>
            <dd>
              <StaticImage src="./img/yoggy.png" alt="簡単瞑想アプリ寝たまんまヨガ 株式会社ヨギーさま" />
            </dd>
            <dd>
              <p>
                本開発前にシステムのフィジビリティチェックが必要になった為、デザインモックを作成。手戻りを最小限に抑えることができ、スケジュールを短縮しつつ、トータルコストの削減に繋がりました。
              </p>
            </dd>
          </dl>
        </SwiperSlide>
        <ul className={styles.pCaseStudies__navigation}>
          <li>
            <button className={styles.prev} type="button" onClick={() => swiperNavigation('prev')}>
              Prev
            </button>
          </li>
          <li>
            <button className={styles.next} type="button" onClick={() => swiperNavigation('next')}>
              Next
            </button>
          </li>
        </ul>
      </Swiper>
    </>
  );
};

const CaseStudies: React.FC = () => {
  const style = classNames(styles.pCaseStudies, contentStyle.lContentFull);

  return (
    <Content
      className={{ wrapper: style, inner: styles.lContent__inner }}
      intersection={{ visible: styles.visible, standby: styles.standby }}
    >
      <CaseStudiesContent />
    </Content>
  );
};

export default CaseStudies;
